export default String.raw`
const ComparerBarUI = (() => {
    'use strict';
    const bar = document.querySelector('.comparison-bar-js');

    if (!bar) {
        return;
    }

    window.addEventListener('comparer:itemsCountChanged', (e) => {
        const itemsCount = e.detail.itemsCount || 0;
        const boxes = bar.querySelectorAll('.comparison__items svg');

        boxes.forEach((box, index) => {
            box.classList.toggle('empty', index >= itemsCount);
        });

        if (itemsCount > 0) {
            bar?.classList.remove('hidden-js');
        }
    });

    window.addEventListener('comparer:added', () => {
        bar?.classList.remove('hidden-js');
    });
    
    window.addEventListener('comparer:empty', () => {
        bar?.classList.add('hidden-js');
    });
})();


`